/**
 * 把不同类型都转为 Error 实例
 * @param err
 * @returns
 */
export default function normalizeError(err: unknown): Error {
    if (err instanceof Error) {
        return err // 直接返回 Error 实例
    }

    if (typeof err === 'string') {
        return new Error(err) // 字符串转换为 Error
    }

    if (typeof err === 'object' && err !== null) {
        // eslint-disable-next-line jst-gyl/disable-empty-catch
        try {
            return new Error(JSON.stringify(err)) // 对象转换为字符串
        } catch (e) {
            return new Error('Unknown error object')
        }
    }

    return new Error('Unknown error') // 其他情况，如 null、undefined、数字等
}
